import appSettings from 'apps/services/config'
import React from 'react'

const LogisticsDashboards = () => {
    return(
        <>
       <iframe
        src={appSettings.dashboard_url+'/logistics-dashboard'}
        title="Example Iframe"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        ></iframe>
       </>
    )
}

export default LogisticsDashboards